import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Stack } from '@mui/material';

import { BreadCrumbs } from 'components/Breadcrumbs';
import { ContentLayout } from 'components/Layout';
import { useAuth } from 'lib/auth';
import { paths } from 'routes';

import { SettingsEntryList } from '../components/SettingsEntryList';
import { SettingsOverlay } from '../components/SettingsOverlay';

export const Settings = () => {
  const { account } = useAuth();
  const [openOverlay, setOpenOverlay] = useState(null);

  if (!account.super_admin) {
    return <Navigate to={paths.homepage} replace />;
  }

  const items = [{ label: 'Fees', onClick: () => setOpenOverlay('fees') }];

  return (
    <ContentLayout title="Settings">
      <Stack height={1}>
        <BreadCrumbs items={[{ name: '', to: '' }, { name: 'Settings' }]} />

        <Stack
          px={4}
          py={2}
          bgcolor="background.paper"
          borderTop="1px solid"
          borderColor="border.main"
          height="100%"
        >
          <SettingsEntryList items={items}>
            {openOverlay === 'fees' && (
              <SettingsOverlay name="Settings" onClose={() => setOpenOverlay(null)} />
            )}
          </SettingsEntryList>
        </Stack>
      </Stack>
    </ContentLayout>
  );
};
